import React, { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import * as QueryString from 'query-string';
import SearchBar from '@components/util/SearchBar';
import { Breadcrumb, Card, Col, Row } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { handleError } from '@rd-web-markets/shared/dist/store/features/alertSlice';
import claimGroupService from '@rd-web-markets/shared/dist/services/claim_group.service';
import ClaimGroupList from '@components/shared/claim_group/list/ClaimGroupList';
import ClaimGroupsListNavigation from '@rd-web-markets/market/dist/claim_group/list/ClaimGroupsListNavigation';
import BreadcrumbsPortal from '@rd-web-markets/shared/dist/util/BreadcrumbsPortal';
import MasterSidebar from '@rd-web-markets/shared/dist/util/MasterSidebar';
import Pagination from '@rd-web-markets/shared/dist/util/Pagination';
import { useTranslation } from 'react-i18next';
import { USE_V2_DESIGN } from '@rd-web-markets/market/dist/constants';
import ClaimsTopLevelNavigation from 'src/pages/admin/v2/ClaimsTopLevelNavigation';

const initialParams = {
  page: 1,
  query: ''
}

const AllClaimGroupsPage = ({ accountType }) => {
  const [claimGroups, setClaimGroups] = useState(null);
  const [totalPages, setTotalPages] = useState(null);
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const [params, setParams] = useState(
    window.location.search ? QueryString.parse(window.location.search) : initialParams
  );

  const fetchData = async () => {
    setLoading(true);
    const response = await claimGroupService.all(QueryString.stringify(params));
    setClaimGroups(response.claim_groups);
    setTotalPages(response.pages);
    history.push({
      path: 'admin/claim_groups',
      search: QueryString.stringify(params),
    });
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, [history, params]);

  const handleSearch = (query) => {
    setParams({ ...params, query, page: 1 });
  };

  const handlePage = (pageNumber) => {
    window.scrollTo(0, 0);
    setParams({ ...params, page: pageNumber });
  };

  const deleteClaimGroup = async claimGroupId => {
    const cg = claimGroups.find(cg => cg.id == claimGroupId)
    if(cg.claim_project_reports_count > 500){
      window.alert("You can't delete this claim because of the large number of projects. Please ask the support engineer for help.")
    } else {
      if(window.confirm('Are you sure you wish to delete this claim group ?')){
        setLoading(true);
        try {
          await claimGroupService.delete(claimGroupId);
          await fetchData();
        } catch(error){
          dispatch(handleError(error));
        };
        setLoading(false);
      }
    }
  };

  return (
    <>
      {!USE_V2_DESIGN && <MasterSidebar accountType={accountType} currentPage='all_claim_groups' />}
      {!USE_V2_DESIGN && (
        <BreadcrumbsPortal>
          <Breadcrumb>
            <Breadcrumb.Item linkAs={Link} linkProps={{to: '/admin'}}>{t('home')}</Breadcrumb.Item>
            <Breadcrumb.Item active>{t('all_claim_groups')}</Breadcrumb.Item>
          </Breadcrumb>
        </BreadcrumbsPortal>
      )}

      <Row className={USE_V2_DESIGN ? 'justify-content-center mx-0 mt-4' : ''}>
        <Col md={USE_V2_DESIGN ? 10 : 12}>
          {USE_V2_DESIGN && <h1 className='fw-bold mb-3' style={{ color: '#0078B9' }}>{t('all_claim_groups')}</h1>}
          { USE_V2_DESIGN && <ClaimsTopLevelNavigation accountType={accountType} /> }

          <Card>
            <Card.Header>
              <ClaimGroupsListNavigation page='claim_groups' isV2={USE_V2_DESIGN} />
            </Card.Header>
            <Card.Body>
              <Row>
                <Col md={12}>
                  <Card>
                    <Card.Header>
                      <Row>
                        <Col md={4}>{t('all_claim_groups')}</Col>
                        <Col md={{ span: 4, offset: 4 }}>
                          <SearchBar onSubmit={handleSearch} loading={loading} query={params.query} />
                        </Col>
                      </Row>
                    </Card.Header>
                    <Card.Body>
                      {claimGroups && <ClaimGroupList deleteClaimGroup={deleteClaimGroup} claimGroups={claimGroups} loading={loading} />}
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
              <Pagination currentPage={Number(params.page)} totalPages={totalPages} handlePageChange={handlePage} />
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  )
}

export default AllClaimGroupsPage
